import { type ReactNode } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./lib/auth";
import { Layout } from "./components/Layout";
import { Landing } from "./pages/Landing";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { CreateServer } from "./pages/CreateServer";
import { ServerDetail } from "./pages/ServerDetail";
import { Admin } from "./pages/Admin";

function Protected({ children, admin }: { children: ReactNode; admin?: boolean }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="spinner">Loading…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}

/** The route tree. Router (Browser/Static) is provided by the entry point. */
export function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Landing />} />
        {/* Pre-launch: catalog & pricing aren't public yet — funnel to the waitlist. */}
        <Route path="/games" element={<Navigate to="/#waitlist" replace />} />
        <Route path="/pricing" element={<Navigate to="/#waitlist" replace />} />
        <Route path="/login" element={<Login mode="login" />} />
        <Route path="/register" element={<Login mode="register" />} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/dashboard/new" element={<Protected><CreateServer /></Protected>} />
        <Route path="/dashboard/servers/:id" element={<Protected><ServerDetail /></Protected>} />
        <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
